import { Component, OnInit } from '@angular/core';
import { Data } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../../app.service';
import { SafetyPositionsVM, UserOverviewModel } from '../../../entities';
import { UserService } from '../../../shared/services/user.service';
import { SiteCodes } from '../../GET_NEW_UI/entities/global/model';
import { User } from '../../GET_NEW_UI/entities/user.model';
import { Form, SearchFormVM, StateVM, TrainingRegFormsVM, TraningRegSearchParametersVM, TraningRegUserVM, VMFormSearch } from '../../GET_NEW_UI/perform-induction/perform-induction';
import { SafetyConfigService } from '../../GET_NEW_UI/services/safety-config.service';
import { SafetyInductionService } from '../../GET_NEW_UI/services/safety-induction.service';
import { ExcelService } from '../../manage-components/excel-service.service';

@Component({
  selector: 'app-training-register-search',
  templateUrl: './training-register-search.component.html',
  styleUrls: ['./training-register-search.component.scss'],
  providers: [ExcelService]
})
export class TrainingRegisterSearchComponent implements OnInit {

  DateComplete = true
  FollowUpDate = false
  IsdateCompleted: boolean = true;
  IsfollowUpDate: boolean = false;

  SelectedForm: number[]
  SelectdState: number[]
  SelectdPosition: number[]
  jobPositionList: SafetyPositionsVM[] = []
  searchUserList: TraningRegUserVM[] = []
  searchedForm: TrainingRegFormsVM[] = []
  Sites: StateVM[];
  FormList: Form[];
  CopyFormList: Form[];


  isLoading: boolean = false
  //isLoading_: boolean = true

  ShowTable: boolean = false
  ShowDownloadExcel: boolean = false

  searchedFormList: SearchFormVM[] = []


  FileterFormList:Form[];
  userList:UserOverviewModel[]=[]
  CopyuserList:UserOverviewModel[]=[]
  FileteruserList:UserOverviewModel[]=[]

  SelectedUser: number[]

  constructor(
    private _appService: AppService,
    private _userService: UserService,
    private _safetyConfigService: SafetyConfigService,
    private _inductionService: SafetyInductionService,
    private _notify: NotificationsService,
    public excelService: ExcelService,

  ) { }

  ngOnInit() {
    this._appService.setPageTitle('Search Training Register');
    //this.getJobPositions()
    //this._inductionService.GetFormSearch().subscribe(res => {
    //  console.log("GetFormSearch", res)
    //  let result: VMFormSearch = res;

    //  // let _state = new StateVM();
    //  // _state.ID = 0
    //  // _state.SideCode = "All";
    //  this.Sites = result.States
    //  // this.Sites.unshift(_state)
    //})
    this._inductionService.TrainingRegisterGetStates().subscribe(res => {
      this.Sites = res;
    })
    this.getJobPositions();
    this.gtAllSafetForms();
    this.loadAllUsers();
  }

  gtAllSafetForms() {
    this._inductionService.gtAllSafetForms().subscribe(res => {
      this.FormList = res
      this.CopyFormList=res;
      //if (res != null && res.length > 0) {
      //  let frm = []
      //  res.map(m => {
      //    if (m.Name) {
      //      frm.push(m)
      //    }
      //  })

      //  this.FormList = frm.sort(function (a, b) {
      //    if (a.Name < b.Name) { return -1; }
      //    if (a.Name > b.Name) { return 1; }
      //    return 0;
      //  })

      //  // let _Form = new Form();
      //  // _Form.Name = "All"
      //  // _Form.ID = 0;
      //  // this.FormList.unshift(_Form)    
      //}
    })
  }

  NavigateToJobPositons() {
    window.open('/job-positions/');
  }
  getJobPositions() {
    this._userService.getActiveSafetyJobPositins().subscribe(res => {
      this.jobPositionList = res

      //  let _positon = new SafetyPositionsVM();
      //  _positon.Id = 0
      //  _positon.positionName = "All";
      //  this.jobPositionList =res
      //  this.jobPositionList.unshift(_positon)
    })
  }


  SitesChanged(event) {
    // console.log(event.value)
    // if(event.value==0){
    //   this.SelectdState=[]
    // }

  }

  // GetUsers(){    
  //   let params= new TraningRegSearchParametersVM();   
  //   params.PositionsIDs=this.SelectdPosition;
  //     this._inductionService.getUsersForTraningReg(params).subscribe(res=>{
  //     console.log(res)      
  //     this.searchUserList=res    
  //     })

  //   }

  onResetClick() {
    this.searchUserList = []
    this.searchedForm = []
    this.SelectdPosition = []
    this.SelectdState = []
    this.SelectedForm = []
    this.SelectedUser=[];

    // this.DateComplete=false
    this.FollowUpDate = false
    this.ShowTable = false
  }

  async onSearch() {
    //  console.log(this.SelectdPosition) 
    //   if(this.SelectdPosition==undefined){
    //     this._notify.error("Please select Position")
    //   }
    //   else{
    this.isLoading = true
    //this.isLoading_ = true

    let params_ = new TraningRegSearchParametersVM();
    params_.PositionsIDs = this.SelectdPosition;
    this._inductionService.getUsersForTraningReg(params_).subscribe(res => {
      console.log("Users",res)
      this.searchUserList = res

      if(this.SelectedUser.length>0){
       // this.searchUserList = this.searchUserList.filter((elem) => this.SelectedUser. => elem.userID === Id));

        this.searchUserList =this.searchUserList.filter(f => this.SelectedUser.includes(f.userID));
      }
      //this.isLoading_ = false
    })

    let FormParams = new TraningRegSearchParametersVM();
    FormParams.FromID = this.SelectedForm;
    FormParams.PositionsIDs = this.SelectdPosition;

    this._inductionService.getSelectedFormsForSearch(FormParams).subscribe(res => {
      console.log(res)
      this.searchedFormList = res
      //this.isLoading_ = false
    })

    let params = new TraningRegSearchParametersVM();
    params.FromID = this.SelectedForm;
    params.PositionsIDs = this.SelectdPosition;
    params.SiteID = this.SelectdState;
    params.UserId = this.SelectedUser;
    await this._inductionService.searchTraingRegister(params).subscribe(res => {
      this.searchedForm = res
      this.ShowTable = true
      this.isLoading = false
      this.ShowDownloadExcel = true
    })

  }

  changeCheckbox(values: string) {
    switch (values) {
      case 'DateComplete':
        this.IsdateCompleted = !this.IsdateCompleted;
        break;
      case 'FollowUpDate':
        this.IsfollowUpDate = !this.IsfollowUpDate;
        break;
    }
  }

  searchedFormFiltered: TrainingRegFormsVM[] = []
  searchedFormFiltered_: TrainingRegFormsVM[] = []

  searchUserList_: TraningRegUserVM[] = []
  DownloadCSVFile() {


    this.searchUserList_ = this.searchUserList.filter(f => f.Forms == null)
    for (let i = 0; i < this.searchUserList_.length; i++) {
      let model = new TrainingRegFormsVM()
      model.FormName = "N/A";
      model.CompletedDate = null
      model.followUpDate = null
      model.StateName = "N/A";
      model.createdUserName = "N/A";
      model.postionName = "N/A";
      model.reltedUserName = this.searchUserList_[i].userName
      model.reltedUserId = this.searchUserList_[i].userID

      this.searchedFormFiltered.push(model)

    }
    console.log(" this.searchUserList_", this.searchUserList_)
    console.log(" this.searchedFormFiltered", this.searchedFormFiltered)
    this.searchedFormFiltered_ = this.searchedForm.concat(this.searchedFormFiltered)
    console.log(" this.searchedForm", this.searchedFormFiltered_)

    let arra_ = [];
    this.searchedFormFiltered_.map(x => {

      if (arra_.length == 0) {
        arra_.push(x);
        console.log("if length 0", arra_)

      } else {
        var check = arra_.find(y => y.reltedUserId == x.reltedUserId && x.FormName == "N/A")
        console.log("check", check)
        if (check == undefined) {
          arra_.push(x);
          console.log("if  length 0>", arra_)
        }
      }
    })
    this.downloadFile(arra_)
  }

  //download csv file
  downloadFile(data: any) {

    console.log("data", data)



    let _data = []

    data.map(p => {
      let _o = {}
      for (var key in p) {
        if (p.hasOwnProperty(key)) {

          if (key == "createdUserName") {
            _o["Created User"] = p[key]
          } else if (key == "FormName") {
            _o["Form Name"] = p[key]
          } else if (key == "postionName") {
            _o["Position"] = p[key]
          } else if (key == "StateName") {
            _o["State"] = p[key]
          } else if (key == "CompletedDate") {
            _o["Date Completed"] = p[key]
          } else if (key == "followUpDate") {
            _o["Follow Up Date"] = p[key]
          } else if (key == "reltedUserName") {
            _o["Related User"] = p[key]
          }
        }
      }
      //}






      _data.push(_o)
    })

    const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(_data[0]);
    let csv = _data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');
    var a = document.createElement('a');
    var blob = new Blob([csvArray], { type: 'text/csv' }),
      url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = `Training Register.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }


  showValue2(FormID, sr: TrainingRegFormsVM) {
    // console.log("yyyyyy",im.Equipment,im.isPrint, im.Name, EquipmentId)


    //  console.log("isContains",isContains)
    if (sr.fromID == FormID) {
      sr.isPrint = true
    }

    else sr.isPrint = false
    // console.log("tttyyyy",im.isPrint)
    return true;
  }


  FilterForms() {
    if (this.SelectdPosition.length > 0) {
      let params_ = new TraningRegSearchParametersVM();
      params_.PositionsIDs = this.SelectdPosition;
      this._inductionService.GetFormsForSelectedPositions(params_).subscribe(res => {
        console.log(res)
        this.FileterFormList =res;
        this.FormList = this.FileterFormList;
       // this.FormList = this.FormList.filter(x=> this.FileterFormList. )
      })
    }else{
      this.FormList = this.CopyFormList;
    }
  }


  FilterUsers(){
    if (this.SelectdPosition.length > 0) {
      let params_ = new TraningRegSearchParametersVM();
      params_.PositionsIDs = this.SelectdPosition;
      this._inductionService.GetUsersForSelectedPositions(params_).subscribe(res => {
        console.log(res)
        this.FileteruserList =res;
        this.userList = this.FileteruserList;
       // this.FormList = this.FormList.filter(x=> this.FileterFormList. )
      })
    }else{
      this.userList = this.CopyuserList;
    }
  }





  loadAllUsers(){
    this._userService.GetAllUsersForJobPosition(0).subscribe(res=>{
      this.userList =res;
      this.CopyuserList=res;
      
     })
  }
}


